/**
 * Code to create placemarks for earth
 * @module
 *
 */


module.exports = {
	
		Riyadh2: {
			text: "الرياض",
			latLng: [24.547123, 46.748093]
		},
		Makkah: {
			text: "مكة",
			latLng: [21.62417, 41.20417]

		},
		Medina: {
			text: "المدينة المنورة",
			latLng: [24.9, 39.5]
		},
		Eastern_Province: {
			text: "المنطقة الشرقية",
			latLng: [24.0, 49.75]
		},
		Asir: {
			text: "عسير",
			latLng: [19.0 ,43.0]
		},
		Tabuk: {
			text: "تبوك",
			latLng: [28.39972, 36.57139]
		},
		Hail: {
			text: "حائل",
			latLng: [27.52167, 41.69056]
		},
		Jazan: {
			text: "جازان",
			latLng: [16.88917 ,42.55111]

		},
		Najran: {
			text: "نجران",
			latLng: [17.49326, 44.12766]
		},
		Qassim: {
			text: "القصيم",
			latLng: [27.08333, 43.46667]
		},
		Baha: {
			text: "الباحة",
			latLng: [20.16667, 41.43333]

		},
		Northern_Borders: {
			text: "الحدود الشمالية",
			latLng: [30.25, 42.41667]

		},
		Al_Jouf: {
			text: "الجوف",
			latLng: [30.05, 39.6]

		}
	
	
};

